import jwtDecode from 'jwt-decode';
import { tokenKey } from '../../config/axios';
export var useAuth = function () {
    var isAuthenticated = function () {
        var tokenStorage = localStorage.getItem(tokenKey);
        var now = Math.floor(Date.now() / 1000);
        if (!tokenStorage)
            return false;
        var token = jwtDecode(tokenStorage);
        if (!token)
            return false;
        return now < token.exp;
    };
    return {
        isAuthenticated: isAuthenticated,
    };
};
